// extracted by css-extract-rspack-plugin
export default {"date":"Show__date--Fp6jc","title":"Show__title--b3k4u","label":"Show__label--t5HJ4","body":"Show__body--wosto"};